<div id="summaryOrder" class="subBlockContainer">
    <div class="subBlockContent">
        <loading-screen *ngIf="!loadContent || !loadSummary" [scrollAfterLoading]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
        <child-header [title]="title" (closeEvent)="close()"></child-header>
        <div #ParentWrapper class="child-body">
            <div class="inner-subBlock-wrapper">
                <div class="page-title-wrapper">
                    <!-- <div class="title blade-title-font">
                        {{title}}
                    </div> -->
                    <span *ngIf="showTimer" style="margin-left: 60%;"><i class="far fa-clock"></i> {{this.counter}}</span>
                    <!-- <i class="material-icons closebutton-pullfloat-right" (click)="close();">close</i> -->
                </div>
                <div class="content content-light color-dark">
                    <div class="checkout-order-header section-container row">
                        <div class="col-md-4" *ngIf="deliverySummary">
                            <app-delivery-summary [deliverySummary]="deliverySummary" [enableEdit]="true"></app-delivery-summary>
                        </div>
                        <div class="col-md-4" *ngIf="paymentSummary">
                            <app-payment-summary [paymentSummary]="paymentSummary" [enableEdit]="true"></app-payment-summary>
                        </div>
                        <div class="col-md-4" *ngIf="partshipSummary">
                            <app-partship-summary *ngIf="showDelivery" [partshipSummary]="partshipSummary" [enableEdit]="true"></app-partship-summary>
                        </div>
                    </div>
                    <div *ngIf="cartDetails" class="mTable checkout-summary-items shared-outer-wrapper">
                        <app-item-summary [cartDetails]="cartDetails" [checkoutSummary]="checkoutSummary"></app-item-summary>
                    </div>
                    <p class="checkout-description description-position"
                    >NOTE: Order processing may take up to 60 seconds</p>
                    <div class="freight-button-list">
                        <button class="button button-red button-mid text-initial" id="next-button" (click)="placeOrder()" [disabled]="isOrderPlaced" *ngIf="currentUserModel?.hasPurchaseAccess">Place order</button>
                    </div>
                    <div id="bottom-navigation" class="bottom-navigation">

                        <button (click)="goPrevious()">Previous</button>
                        <span>&nbsp;|&nbsp;</span>
                        <!-- <button (click)="backtoCart()">Back to cart</button> -->
<!--                        <ng-container *ngIf="serial;else goRenewals">-->
<!--                            <button class="btnLink" (click)="backtoRenewals()">Back to renewals</button>-->
<!--                        </ng-container>-->
<!--                        <ng-template #goRenewals>-->
<!--                            <button class="btnLink" (click)="backtoCart()">Back to cart</button>-->
<!--                        </ng-template>-->

                      <ng-container [ngSwitch]="backto">
                        <button *ngSwitchCase="'renewal'" (click)="backtoRenewals()">Back to renewals
                        </button>
                        <button *ngSwitchCase="'quote'"  (click)="backtoQuotes()">Back to quotes
                        </button>
                        <button *ngSwitchDefault  (click)="backtoCart()">Back to cart</button>
                      </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
